import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthProvider';
import { useUserPermissions } from '@/hooks/useUserPermissions';
import { listEntityDocuments, documentError } from '@/lib/documentsApi';
import { POSavedDocumentList } from './POAttachmentPanel';

export default function POAttachmentsViewer({ poId }) {
  const { user } = useAuth();
  const { hasPermission } = useUserPermissions();
  if (!hasPermission('procurement.po.view') || !poId) return null;
  return <ScopedViewer key={`${user?.id}:${user?.company_id}:${user?.unit_id}:${poId}`} poId={poId} />;
}
function ScopedViewer({ poId }) {
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!open) return;
    const controller = new AbortController(); let active = true;
    setLoading(true); setRows([]); setError('');
    listEntityDocuments('purchase_order', poId, controller.signal)
      .then(data => { if (active) setRows(data); })
      .catch(cause => { if (active && !controller.signal.aborted) setError(documentError(cause)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [open, poId, refresh]);
  return <section className="my-4 space-y-4 rounded-xl border border-slate-200 bg-white p-4 text-slate-900"><button type="button" aria-expanded={open} onClick={() => setOpen(value => !value)} className="font-semibold text-blue-700">{open ? 'Hide' : 'View'} PO supporting documents</button>{open && <POSavedDocumentList documents={rows} loading={loading} error={error} onRefresh={() => setRefresh(value => value + 1)} />}</section>;
}
